import $ from 'jquery';

export function customJS() {
  $(document).ready(function ($) {
    $('.sidebar__body ul li a').each(function () {
      $(this).before('<i class="fa fa-chevron-right"></i>');
      // cache jquery var
    });

    var windowSize = $(window).width();


    $.fn.is_on_screen = function () {
      var win = $(window);
      var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();

      var bounds = this.offset();
      bounds.right = bounds.left + this.outerWidth();
      bounds.bottom = bounds.top + this.outerHeight();

      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };
    let additionalSubMenu = false;


    $('body').on('click', '.menu-toggle, .menu_toggle', function () {
      $(this).toggleClass('open');
      $(this).parents().find('.main_menu_nav').slideToggle(300);
      if (!additionalSubMenu) {
        $("body .main_menu_nav > li.menu-item-has-children > a").after('<span class="arrow"><i></i></span>');
        $("body .main_menu_nav > li.menu-item-has-children > .sub-menu > .menu-item-has-children > a").after('<span class="arrow"><i class="fa fa-chevron-down"></i></span>');
        additionalSubMenu = true;
      }
      return false;
    });
    $('body').on('click', '#menu_toggle_button', function () {
      $(this).toggleClass('open');
      $('#header').each(function () {
        if (!$(this).hasClass('show')) {
          $(this).addClass('show');
          if ($('body').hasClass('rtl')) {
            $(this).animate({right: "0"}, 300);
          } else {
            $(this).animate({left: "0"}, 300);
          }
        } else {
          $(this).removeClass('show');
          if ($('body').hasClass('rtl')) {
            $(this).animate({right: "-100%"}, 600);
          } else {
            $(this).animate({left: "-100%"}, 600);
          }
        }
      });

      return false;
    });


    $('body').on('click', ".main_menu_nav > li.menu-item-has-children .arrow", function () {
      let $this = $(this);
      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.parent().removeClass('active').find('> ul').slideUp(300);
      } else {
        $this.closest('ul').find('li').removeClass('active');
        $this.closest('ul').find('li .arrow').removeClass('active');
        $this.closest('ul').find('li ul').slideUp(300);
        $this.parent().find('> ul').slideDown(300);
        $this.addClass('active');
        $this.parent().addClass('active');
      }
    });

    $('body').on('hover', ".main_menu_nav > li.menu-item-has-children a ", function () {
      let $this = $(this);
      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.parent().removeClass('active').find('> ul').slideUp(300);
      } else {
        $this.closest('ul').find('li').removeClass('active');
        $this.closest('ul').find('li .arrow').removeClass('active');
        $this.closest('ul').find('li ul').slideUp(300);
        $this.parent().find('> ul').slideDown(300);
        $this.addClass('active');
        $this.parent().addClass('active');
      }
    });


// Stiky Header
    var headerHeight = $("#header").height();
    var headerTop = $(".header_top").height();
    var topBar = $(".top_bar").height();

// $("#header.dynassurance .nav-box, #header.dynassurance .header_top").affix({
//   offset: {
//     top: headerHeight
//   }
// });
//
// $("#menu_toggle_button.dynassurance, .menu_toggle_button.dynassurance").affix({
//   offset: {
//     top: topBar
//   }
// });

    $("body").on("scroll", function () {
      if ($(".header_top, .nav-box").hasClass('affix')) {
        $("#header.dynassurance").css("paddingBottom", headerTop);
      } else {
        $("#header.dynassurance").css("paddingBottom", 0);
      }
    });

    $("body").on('click', '.top_bar_info_switcher .active', function () {
      if ($(".top_bar_info_switcher ul").is(':visible')) {
        console.log('NEED TO SHOW top bar');
        $(this).parent().find("ul").slideUp(100);
      } else {
        console.log('NEED TO CLOSE top bar');
        $(this).parent().find("ul").slideDown(100);
      }

      return false;
    })
  });
}



// WEBPACK FOOTER //
// ./src/mixins/customJS.js